const getDaysLeft = (insuranceDateString: string) => {
  const today = new Date();
  const insuranceDate = new Date(insuranceDateString);

  let nextRenewal = new Date(
    today.getFullYear(),
    insuranceDate.getMonth(),
    insuranceDate.getDate(),
    insuranceDate.getHours(),
    insuranceDate.getMinutes(),
    insuranceDate.getSeconds()
  );

  if (nextRenewal < today) {
    nextRenewal.setFullYear(nextRenewal.getFullYear() + 1);
  }

  const diffMs = nextRenewal.getTime() - today.getTime();
  const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

  return diffDays;
};

export { getDaysLeft };
